/**
 * ================================================================
 * PrettyBirds – Product Selector + Color Tab Bridge
 * File: assets/product-selector-prestige.js
 *
 * Khi khách click swatch → dispatch CustomEvent 'pb:colorChange'
 * → AI tab component lắng nghe và tự cập nhật label + content
 * ================================================================
 */

(function () {
  'use strict';

  function init() {

    const swatchWrapper = document.getElementById('pb-product-group');
    if (!swatchWrapper) return;

    /* ── 1. Parse JSON data block ── */
    let colorMap = {};
    try {
      const dataEl = document.getElementById('pb-product-group-data');
      if (dataEl) {
        const parsed   = JSON.parse(dataEl.textContent);
        const products = parsed.products || [];
        products.forEach(function (p) {
          colorMap[p.url] = {
            name:  p.color      || '',
            desc:  p.colorDesc  || '',
            image: p.colorImage || ''
          };
        });
      }
    } catch (e) {
      console.warn('[PrettyBirds] JSON parse error:', e);
    }

    /* ── 2. DOM refs ── */
    const styleTabs  = swatchWrapper.querySelectorAll('.pb-tab');
    const swatches   = swatchWrapper.querySelectorAll('.pb-swatch');
    const swatchList = swatchWrapper.querySelector('.pb-swatch-list');
    const topLabel   = document.getElementById('pb-current-color');

    /* ── 3. Style tab filter ── */
    styleTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        styleTabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var style = tab.dataset.style;
        swatches.forEach(function (sw) {
          sw.style.display = (style === 'all' || sw.dataset.style === style) ? '' : 'none';
        });
      });
    });

    /* ── 4. Dispatch helper ──
       Gửi CustomEvent để AI tab component nhận
    ── */
    function dispatchColorChange(data) {
      document.dispatchEvent(new CustomEvent('pb:colorChange', {
        bubbles: true,
        detail: {
          name:  data.name  || '',
          desc:  data.desc  || '',
          image: data.image || ''
        }
      }));
    }

    /* ── 5. Swatch hover → preview tên màu ── */
    swatches.forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        var data = colorMap[sw.getAttribute('href')];
        if (data && topLabel) topLabel.textContent = data.name;
      });
      sw.addEventListener('focus', function () {
        var data = colorMap[sw.getAttribute('href')];
        if (data && topLabel) topLabel.textContent = data.name;
      });
    });

    if (swatchList) {
      swatchList.addEventListener('mouseleave', function () {
        var active = swatchWrapper.querySelector('.pb-swatch.is-active');
        if (active) {
          var data = colorMap[active.getAttribute('href')];
          if (data && topLabel) topLabel.textContent = data.name;
        }
      });
    }

    /* ── 6. Swatch click → cập nhật color tab ──
       *** ĐÂY LÀ PHẦN CHÍNH ***
    ── */
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        var url  = sw.getAttribute('href');
        var data = colorMap[url];
        if (!data || !data.name) return;

        /* Cập nhật top label */
        if (topLabel) topLabel.textContent = data.name;

        /* Dispatch event → AI tab component tự xử lý */
        dispatchColorChange(data);

        /* Uncomment dòng dưới nếu KHÔNG muốn navigate sang trang khác */
        /* e.preventDefault(); */
      });
    });

    /* ── 7. Init khi page load ── */
    var activeSwatch = swatchWrapper.querySelector('.pb-swatch.is-active');
    if (activeSwatch) {
      var initData = colorMap[activeSwatch.getAttribute('href')];
      if (initData) {
        if (topLabel) topLabel.textContent = initData.name;
        dispatchColorChange(initData);
      }
    }

    /* ── 8. Show all Colors collapse (toàn bộ group) ── */
    applyCollapse(swatchWrapper);

  }

  /* ── Collapse helper — reusable on init and after variant re-render ── */
  var _groupExpanded = false;

  function applyCollapse(sw) {
    if (!sw) return;
    var btn = sw.querySelector('.pb-show-all-btn');
    if (!btn) return;

    if (!_groupExpanded && sw.scrollHeight > 175) {
      sw.classList.add('is-collapsed');
    }

    /* btn is a fresh DOM node after rerender — always re-attach listener */
    btn.addEventListener('click', function () {
      sw.classList.remove('is-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      _groupExpanded = true;
    });
  }

  /* ── Re-apply collapse after Prestige's product-rerender replaces the liquid block ──
     variant:change fires synchronously before the browser paints, so adding
     is-collapsed here prevents any visible layout shift (fixes desktop jitter).
     Because the layout shift is eliminated, element.focus() in onRerender_fn no
     longer needs to scroll — fixing the mobile scroll-jump as a side-effect. ── */
  document.addEventListener('variant:change', function () {
    applyCollapse(document.getElementById('pb-product-group'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
